import React from "react"

function IconHeartFilled({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (<svg  fill={color} fuze-icon="heart-filled"viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{height: height || fontSize}} originalclass="fz-icon fz-icon-heart-filled"{...props}><path d="M8.074 4.9A4.47 4.47 0 0 0 4.83 6.305c-1.774 1.857-1.773 4.835 0 6.694l6.522 6.847a.812.812 0 0 0 1.187-.007l6.52-6.833c1.776-1.857 1.776-4.837 0-6.694l-.165-.165a4.454 4.454 0 0 0-6.329.165l-.619.641-.621-.648A4.484 4.484 0 0 0 8.075 4.9z" fill={color} fillRule="evenodd" style={{height: height || fontSize}} originalclass="__primary"/></svg>)
}

export default IconHeartFilled
